import React, {useEffect, useState} from 'react';
import {doHttpRequest} from "../../util/NetUtil";
import {isNull} from "../../util/Validators";
import DeleteIcon from '@mui/icons-material/Delete';

export default function Dashboard() {

    const [auth, setAuth] = useState(false);
    const [data, setData] = useState({
        registrations: [],
        abstracts: [],
        data: [],
        loaded: false
    })

    const buildMap = () => {

        const ret = {};

        if (data.data.length > 0) {
            data.data.forEach(item => {
                ret[item.registration.id] = item.visible;
            })
        }

        return ret;
    }

    const registrationMap = buildMap();

    useEffect(() => {
        if (!auth) {
            console.log("Fetching auth state");
            doHttpRequest(
                "/dashboard/isauthed",
                null,
                response => {
                    if (response.code !== 200) {
                        window.location = "/admin-login";
                    } else {
                        setAuth(true);
                    }
                },
                error => {
                    console.log(error);
                },
                "GET"
            )
        }
    }, []);

    useEffect(() => {
        if (!data.loaded && auth) {

            console.log("Loading payload");
            doHttpRequest(
                "/dashboard/fetchdata",
                null,
                (response) => {
                    console.log(response);
                    setData({...data,
                        registrations: response.registrations,
                        abstracts: response.abstracts,
                        data: response.registrationData
                    });
                }, error => {
                    alert("Failed to load data.  Reason: " + error.message);
                },
                "GET");

        }
    }, [auth]);

    const handleDelete = (reg) => {
        console.log("Delete " + reg.id)
        doHttpRequest(
            "/dashboard/disable?id="+reg.id,
            null,
            (response) => {
                if (response.code === 200) {
                    window.location = window.location;
                }
            }, error => {
                alert("Failed to load data.  Reason: " + error.message);
            },
            "GET");
    }

    return (
        <React.Fragment>
            <div
                style={{
                    width: "90%",
                    margin: "auto",
                    borderRadius: "5px",
                    marginTop: "30px",
                    fontSize: "20px"
                }}
            >
                <div style={{
                    alignContent: "center",
                    textAlign: "center",
                    marginBottom: "5px",
                    fontWeight: "bold",
                    fontSize: "30px"
                }}>
                    Registration Details
                </div>

                <div
                    style={{
                        width: "100%",
                        border: "solid 1px",
                    }}
                >
                    <table width={"100%"}>
                        <thead>
                            <tr style={{
                                backgroundColor: "white",
                                color: "#0d0c36"
                            }}>
                                <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>First Name</td>
                                <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Last Name</td>
                                <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Email Address</td>
                                <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Company</td>
                                <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Title</td>
                                <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Mobile</td>
                                <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Confirmation Code</td>
                                <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Hide</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data.registrations.map((reg,idx) => {
                                    if (isNull(registrationMap[reg.id]) || registrationMap[reg.id]) {
                                        return <tr key={"row_" + idx}>
                                            <td style={{
                                                borderBottom: "solid 1px"
                                            }}>{reg.firstname}</td>
                                            <td style={{
                                                borderBottom: "solid 1px"
                                            }}>{reg.lastname}</td>
                                            <td style={{
                                                borderBottom: "solid 1px"
                                            }}>{reg.email}</td>
                                            <td style={{
                                                borderBottom: "solid 1px"
                                            }}>{reg.company}</td>
                                            <td style={{
                                                borderBottom: "solid 1px"
                                            }}>{reg.title}</td>
                                            <td style={{
                                                borderBottom: "solid 1px"
                                            }}>{reg.mobile}</td>
                                            <td style={{
                                                borderBottom: "solid 1px"
                                            }}>{reg.confirmationCode}</td>
                                            <td style={{
                                                borderBottom: "solid 1px"
                                            }}
                                            onMouseEnter={(obj)=>obj.target.style.cursor = "pointer"}>
                                                <DeleteIcon onClick={() => handleDelete(reg)}/>
                                            </td>
                                        </tr>
                                    }

                                    return "";
                                })
                            }
                        </tbody>
                    </table>
                </div>


                {/*ABSTRACTS*/}
                <div style={{
                    alignContent: "center",
                    textAlign: "center",
                    marginBottom: "5px",
                    fontWeight: "bold",
                    fontSize: "30px",
                    marginTop: "30px"
                }}>
                    Abstract Details
                </div>
                <div
                    style={{
                        width: "100%",
                        border: "solid 1px",
                    }}
                >
                    {/*{*/}
                    {/*    "id": 1,*/}
                    {/*    "title": "Tester",*/}
                    {/*    "type": "poster",*/}
                    {/*    "abstractDetails": "Tester",*/}
                    {/*    "presenter": null,*/}
                    {/*    "documents": [*/}
                    {/*    "saving.png"*/}
                    {/*    ]*/}
                    {/*}*/}

                    <table width={"100%"}>
                        <thead>
                        <tr style={{
                            backgroundColor: "white",
                            color: "#0d0c36"
                        }}>
                            <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Presenter</td>
                            <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Type</td>
                            <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Title</td>
                            <td width="50%" style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Details</td>
                            <td style={{fontWeight: "bold", borderBottom: "solid 1px"}}>Document Count</td>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            data.abstracts.map(ab => {
                                return <tr>
                                    <td style={{
                                        borderBottom: "solid 1px"
                                    }}>{ab.presenter.firstname + " " + ab.presenter.lastname}</td>
                                    <td style={{
                                        borderBottom: "solid 1px"
                                    }}>{ab.type}</td>
                                    <td style={{
                                        borderBottom: "solid 1px"
                                    }}>{ab.title}</td>
                                    <td style={{
                                        borderBottom: "solid 1px"
                                    }}><div style={{margin: "20px"}}>
                                        {ab.abstractDetails}
                                        </div>
                                    </td>
                                    <td
                                        width={"80px"}
                                        style={{
                                        borderBottom: "solid 1px",
                                    }}>{ab.documents.length}</td>
                                </tr>
                            })
                        }
                        </tbody>
                    </table>
                </div>

            </div>
        </React.Fragment>
    )
}